import { APP_TOKEN } from '../utils/constants';

export interface User {
  token: string;
  userId: string;
  name: string;
  email: string;
  receiverHash?: string;
}

const setUser = (user: User) => {
  console.log('📋 Salvando dados do usuário:', { ...user, token: user.token ? '[REDACTED]' : null });
  console.log('📋 ID do receiver (hash):', user.receiverHash || 'Não definido');
  
  localStorage.setItem(APP_TOKEN, JSON.stringify({
    ...user,
    accepted: true,
  }));
};

const getUser = (): User => {
  const userData = localStorage.getItem(APP_TOKEN);
  const user = JSON.parse(userData || '{}');
  
  console.log('📋 Obtendo dados do usuário:', { 
    ...user, 
    token: user.token ? '[REDACTED]' : null 
  });
  console.log('📋 Receiver Hash do usuário:', user.receiverHash || 'Não definido');
  console.log('📋 User ID:', user.userId || 'Não definido');
  
  return user;
};

const removeUser = (): void => {
  console.log('📋 Removendo dados do usuário');
  localStorage.removeItem(APP_TOKEN);
};

const getToken = () => {
  const { token } = JSON.parse(localStorage.getItem(APP_TOKEN) || '{}');
  if (token) {
    const firstChars = token.substring(0, 10);
    const lastChars = token.substring(token.length - 10);
    console.log(`📋 Token do usuário: ${firstChars}...${lastChars}`);
  } else {
    console.log('📋 Token do usuário não encontrado');
  }
  return token;
};

const getName = () => {
  const { name } = JSON.parse(localStorage.getItem(APP_TOKEN) || '{}');
  console.log('📋 Nome do usuário:', name || 'Não definido');
  return name || '';
};

export {
  setUser,
  getUser,
  removeUser,
  getToken,
  getName,
};
